import { Button } from '@mui/material';
import { isDeleteAllowed, isUpdateAllowed } from '../../../utils/common-utils';
import { CALCULATION_TYPE_OPTIONS, VALUE_MODE_OPTIONS, getDepartmentsLabel} from './utils';

const getOptionLabel = (options, value) =>
  options.find((option) => option.value === value)?.label || value || '-';

export const getHeaderConfig = (departmentList = []) => {
  const config = [
    {
      label: 'Charge Code',
      id: 'chargeCode',
    },
    {
      label: 'Charge Name',
      id: 'chargeName',
    },
    {
      label: 'HSN Code',
      id: 'hsnCode',
    },
    {
      label: 'Calculation Type',
      id: 'calculationType',
      render: (data) => getOptionLabel(CALCULATION_TYPE_OPTIONS, data?.calculationType),
    },
    {
      label: 'Value Mode',
      id: 'valueMode',
      render: (data) => getOptionLabel(VALUE_MODE_OPTIONS, data?.valueMode),
    },
    {
      label: 'Tax Rate',
      id: 'taxRate',
      render: (data) => (data?.taxable ? `${data?.taxRate ?? 0}%` : 'Not Taxable'),
    },
    {
      label: 'Departments',
      id: 'departments',
      render: (data) => getDepartmentsLabel(data?.departments, departmentList),
    },
    {
      label: 'Status',
      id: 'isActive',
      render: (data) => (data?.isActive ? 'Active' : 'Inactive'),
    },
    {
      label: 'Actions',
      id: 'actions',
      render: (data, onClick) => {
        return (
          <>
            <Button
              disabled={!isUpdateAllowed('master_data')}
              variant="text"
              onClick={() => onClick(data, 'EDIT')}
            >
              Edit
            </Button>
            <Button
              disabled={!isDeleteAllowed('master_data')}
              variant="text"
              onClick={() => onClick(data, 'DELETE')}
            >
              Delete
            </Button>
          </>
        );
      },
    },
  ];

  return config;
};
